import { defineStore } from 'pinia';
import { ref, shallowRef } from 'vue';

export const useModalStore = defineStore('modal', {
  state: () => ({
    isVisible: false,
    title: null as string | null,
    description: null as string | null,
    noPadding: false,
    closeIcon: false,
    component: null as any,
    componentProps: {} as Record<string, any>,
  }),
  actions: {
    openModal({
      title,
      description,
      component,
      props = {},
      options = {},
    }: {
      title: string;
      description: string;
      component: any;
      props?: object;
      options?: { noPadding?: boolean; whiteIcon?: boolean };
    }) {
      this.title = title;
      this.description = description;
      this.component = component;
      this.componentProps = props;
      this.noPadding = options.noPadding ?? false;
      this.closeIcon = options.whiteIcon ?? false;
      this.isVisible = true;
    },
    closeModal() {
      this.isVisible = false;
      this.title = '';
      this.description = '';
      this.component = null;
      this.componentProps = {};
    },
  },
});
